/**
 * Created by natalia.petrov on 7/18/2017.
 */
import Select from 'react-select';
import styled from 'styled-components';
import { getContrastWhiteBlack } from '../../../utils/helpers';

//todo: keep StyledSelect and StyledSelectAsync identical
export const StyledSelect = styled(Select)`
    &.Select--multi .Select-value{
        border:solid 1px ${props => props.theme.borderColor};
        color:${props => props.theme.buttonContent}; 
        background-color:${props => props.theme.buttonBackground};
    }
    .Select-option-group-label {
        background: ${props => props.theme.brandColor};
        color:  ${props => props.theme.brandContrast};
    }
    .Select-option {
        color: ${props => props.theme.textColor};
    }
    .Select-option:hover{
        background-color: ${props => props.theme.hoverColor};
        color:${props => getContrastWhiteBlack(props.theme.hoverColor)};
    }
    .Select-menu-outer {
        border: 1px solid ${props => props.theme.borderColor};
        border-top-color:${props => props.theme.brandColor} ;
    }
    &.menu-outer-top .Select-menu-outer {
        top: auto;
        bottom: 35px!important;
        border-bottom-right-radius: 0px!important;
        border-bottom-left-radius: 0px!important;
        border-top-right-radius: 4px!important;
        border-top-left-radius: 4px!important;
        border: 1px solid ${props => props.theme.borderColor};
        border-bottom-color:${props => props.theme.brandColor} ;
    }
    .is-focused:not(.is-open) > .Select-control {
        border-color: ${props => props.theme.brandColor};
        box-shadow: inset 0 1px 1px ${props =>
          props.theme.boxShadowTheme}), 0 0 0 3px ${props =>
  props.theme.boxShadowTheme});
    }
    
    .Select-option.is-focused {
        background-color:${props => props.theme.hoverColor};
        color:${props => getContrastWhiteBlack(props.theme.hoverColor)};
    }
    .Select-option.is-selected {
        background-color: ${props => props.theme.brandColor};
        color:${props => props.theme.brandContrast};
    }
    .Select-clear-zone{
    display: none;
  }
  .Select-value-icon:hover,
  .Select-value-icon:focus{
    background-color: ${props => props.theme.buttonBackgroundDarken};
    color:${props => getContrastWhiteBlack(props.theme.buttonBackgroundDarken)};
  }
  .Select-value-icon::before {
    content: "x";
    color:${props => props.theme.buttonContent}; 
    right: -3px;
    top: 1px;
    position: relative;
  }
  .Select-value-label {
    border-left: solid 1px ${props => props.theme.borderColor};
  }
`;

export const StyledSelectAsync = styled(Select.Async)`
    &.Select--multi .Select-value{
        border:solid 1px ${props => props.theme.borderColor};
        color:${props => props.theme.buttonContent}; 
        background-color:${props => props.theme.buttonBackground};
    }
    .Select-option-group-label {
        background: ${props => props.theme.brandColor};
        color:  ${props => props.theme.brandContrast};
    }
    .Select-option {
        color: ${props => props.theme.textColor};
    }
    .Select-option:hover{
        background-color: ${props => props.theme.hoverColor};
        color:${props => getContrastWhiteBlack(props.theme.hoverColor)};
    }
    .Select-menu-outer {
        border: 1px solid ${props => props.theme.borderColor};
        border-top-color:${props => props.theme.brandColor} ;
    }
    &.menu-outer-top .Select-menu-outer {
        top: auto;
        bottom: 35px!important;
        border-bottom-right-radius: 0px!important;
        border-bottom-left-radius: 0px!important;
        border-top-right-radius: 4px!important;
        border-top-left-radius: 4px!important;
        border: 1px solid ${props => props.theme.borderColor};
        border-bottom-color:${props => props.theme.brandColor} ;
    }
    .is-focused:not(.is-open) > .Select-control {
        border-color: ${props => props.theme.brandColor};
        box-shadow: inset 0 1px 1px ${props =>
          props.theme.boxShadowTheme}), 0 0 0 3px ${props =>
  props.theme.boxShadowTheme});
    }
    
    .Select-option.is-focused {
        background-color:${props => props.theme.hoverColor};
        color:${props => getContrastWhiteBlack(props.theme.hoverColor)};
    }
    .Select-option.is-selected {
        background-color: ${props => props.theme.brandColor};
        color:${props => props.theme.brandContrast};
    }
    .Select-clear-zone{
    display: none;
  }
  .Select-value-icon:hover,
  .Select-value-icon:focus{
    background-color: ${props => props.theme.buttonBackgroundDarken};
    color:${props => getContrastWhiteBlack(props.theme.buttonBackgroundDarken)};
  }
  .Select-value-icon::before {
    content: "x";
    color:${props => props.theme.buttonContent}; 
    right: -3px;
    top: 1px;
    position: relative;
  }
  .Select-value-label {
    border-left: solid 1px ${props => props.theme.borderColor};
  }
`;



// WEBPACK FOOTER //
// ./components/utils/Styled/select.js